import PortfolioEdit from './PortfolioEdit';
import PortfolioCreate from './PortfolioCreate';

export default {
  name: 'procurement-portfolios-handled',
  edit: PortfolioEdit,
  create: PortfolioCreate,
};
